<template>
    <div class="">
        <div class="box">
            <div class="box1">
                <div class="left_box">
                   
                    <h5 class="font-active mb-0">Handcrafted with Perfection</h5>
                    <div class="text_box">
                        <div class="text_in">
                            <p>
                                At Friendly Diamonds, each diamond and jewelry is carefully handcrafted with love, passion and attention to detail ensuring we always meet the highest standard of craftsmanship and quality.
                            </p>
                            <p>With over 10,000 satisfied customers, we are honored to have earned the trust and admiration of couples around the world.</p>
                            <p class="mb-0">Don’t just take our word for it- read testimonials from our happy customers!</p>
                        </div>
                        <div class="view_test">
                            <NuxtLink :to="localePath('/testimonials')">VIEW TESTIMONIALS</NuxtLink>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box2">
                <div class="gig_box">
                     <img width="1986" height="944" src="/assets/new-eng-landing/handcrafted/testimonials.gif" alt="Handcrafted Testimonials GIF">
                </div>
            </div>
        </div>
    </div>
</template>


<script setup>
   const localePath = useLocalePath();
</script>

<style scoped>
.box {
    display: flex;
}

.box1 {
    flex: 40%;
    margin-right: 20px;
}

.box2 {
    flex: 60%;
}

.gig_box img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
}

.gig_box {
    height: 100%;
}

.left_box {
    padding: 50px 32px;
    background: #EAE9EA;
    border: 1px solid #EAEAEA
}

.text_box {
    font-size: 16px;

    font-weight: 400;
    text-align: left;

}

.view_test a {
    font-size: 16px;
    color: #BE871A;
    letter-spacing: 2px;
    font-style: normal;
    text-decoration: underline;
}

h5 {
    color: #212529;
    font-size: 32px;
    /* margin-bottom: 20px; */
}

.text_in {
    padding: 32px 0;
}

.text_in p {
    font-size: 16px;
    color: #606060;
    margin-bottom: 12px;
}

.left_box {
    border: 1px solid #eaeaea;
    border-radius: 8px;
}

.left_box img {
    object-fit: cover;
}

@media (max-width:992px) {
    .box {
        flex-direction: column;
    }

    .box1 .box2 {
        width: 100%;
    }

    .left_box {
        padding: 24px 28px;
        background: #EAE9EA;
    }

    .box1 {
        margin: 0;
    }

    .left_box {
        margin-bottom: 10px
    }
}

@media (max-width:767px) {
    h5 {
        font-size: 24px;

    }
    .text_in{
        padding: 25px 0;
    }
        .text_in p {
        font-size: 14px;

    }

    .view_test a {
        font-size: 14px;
    }
}
</style>